(function (global) {
    define('LNRS/Components/Forms/Feedback',[
        "jquery", "vue", "eventManager", "LNRS/Components/Forms/ValidationOptions", "LNRS/Components/Forms/NonEloquaBase", "jqueryValidate", "jqueryUnobtrusiveAjax", "bootstrapSelect", "Validation/RecaptchaApiLoader"
    ], function ($, Vue, eventManager, vo, neBase) {

        var feedbackFormErrorList = [];

        var component = {
            mounted: function () {
                this.formName = "Feedback"; // used for analytics
                $.validator.setDefaults(vo.getDefaultOptions());
                $.validator.unobtrusive.options = vo.getUnobtrusiveOptions();

                this.$purposeList = $(".selectpicker", this.$el);
                this.$purposeList.addClass("form-control").selectpicker("style");

                this.initClientValidationEvents();

                this.$recaptchaPlaceholders = $(".g-recaptcha", this.$el);
                eventManager.subscribe('RecaptchaApiLoaded', this.onloadRecaptchaCallback.bind(this));

                this.initErrorList();


                this.$form = $("#" + this.formId, this.$el);
                this.$form.validate();

                this.$result = $("#result-" + this.formId, this.$el);

                this.loaded = true;
            },
            computed: {
                disableBtn: function () {
                    return false;
                }
            },
            methods: {
                onloadRecaptchaCallback: function () {
                    if (this.$recaptchaPlaceholders.length > 0) {
                        neBase.loadRecaptchaCallbackV3(this.$recaptchaPlaceholders, this.recaptchaCallback);
                    }
                },
                recaptchaCallback: function () {
                    this.removeErrorFromErrorList("ReCaptcha");
                    var recaptchaErrorLabel = $("label[for='ReCaptcha']", this.$el);
                    if (recaptchaErrorLabel) {
                        recaptchaErrorLabel.remove();
                    }
                },
                removeErrorFromErrorList: function (id) {
                    var errIndex = feedbackFormErrorList.indexOf(id);
                    if (errIndex > -1) {
                        feedbackFormErrorList.splice(errIndex, 1);
                    }
                },
                onBlur: function (e) {
                    this.validateInput(e.currentTarget, false);
                },
                validateInput: function (e, isForSubmition) {
                    var err = neBase.validateInput(e, isForSubmition, feedbackFormErrorList);
                    if (err) {
                        this.$form.validate().showErrors(err);
                        neBase.trackErrors(this.formName, Object.keys(err).map(function (key) { return err[key]; }));
                    }
                },
                initErrorList: function () {
                    var language = $(this.$form).find("#LanguageName:first").val();
                    if (language !== 'zh-CN') {
                        this.addToErrorList("ReCaptcha");
                    }
                    this.addToErrorList("MessageBody");
                },
                addToErrorList: function (id) {
                    var errIndex = feedbackFormErrorList.indexOf(id);
                    if (errIndex === -1) {
                        feedbackFormErrorList.push(id);
                    }
                },
                initClientValidationEvents: function () {
                    $("#MessageBody", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                    $("#Email", this.$el).on("blur", function (e) { this.onBlur(e); }.bind(this));
                },
                btnClick: function (e) {
                    e.preventDefault();
                    if (!this.loading) {
                        this.submitForm(e);
                    }
                },
                btnBackClick: function(e) {
                    e.preventDefault();
                    this.$result.hide().removeClass("in");
                    this.sent = false;
                    grecaptcha.reset();
                    this.initErrorList();
                    setTimeout(function() { this.$purposeList.selectpicker("val", "0").selectpicker("refresh"); }.bind(this), 200);
                },
                submitForm: function () {
                    this.loading = true;
                    var self = this;

                    if (feedbackFormErrorList.length > 0) {
                        _.each(feedbackFormErrorList, function (e) {
                            this.validateInput($("#" + e, this.$el).get(0), true);
                        }.bind(this));
                        this.loading = false;
                        return;
                    }

                    // send all fields, with only yes/no for PII data
                    neBase.trackResponses(this.formName, [
                        "Purpose of visit=" + $("#Purpose", this.$el).val(),
                        "Email=" + ($("#Email", this.$el).val() ? "yes" : "no"),
                        "Message Body=" + ($("#MessageBody", this.$el).val() ? "yes" : "no")
                    ]);

                    //LNRSSUP-253
                    $('#FormPageUrl').val(window.location.href);
                    
                    if (this.$recaptchaPlaceholders.length > 0) {
                        var clientId = $(self.$el).find('.recaptchaClientId').first().val();
                        var actionName = $(self.$el).find('.recaptchaActionName').first().val();
                        
                        grecaptcha.ready(function () {
                            grecaptcha.execute(clientId, { action: actionName })
                                .then(function (token) {
                                    this.saveData();
                                }.bind(this));
                        }.bind(this));
                    }
                    else {
                        this.saveData();
                    }                 
                },
                saveData: function () {
                    $.ajax(neBase.submitObj(this.$form))
                    .fail(function (response) {
                        var errors = neBase.submitFail(response);
                        if (!_.isEmpty(errors)) {
                            console.log(errors);
                            this.$form.data("validator").showErrors(errors);
                        }
                        
                    }.bind(this))
                    .always(function (response) {
                        var responseResult = neBase.submitSuccess(response, this.$form, this.$result);
                        this.resultTitle = responseResult.resultTitle;
                        this.resultText = responseResult.resultText;
                        this.sent = responseResult.sent;
                        this.loading = false;
                    }.bind(this));
                }
            }
        };

        return function initFeedbackForm(args) {
            component.el = args.scope;
            component.data = {
                loaded: false,
                formId: args.FormId,
                loading: false,
                sent: false,
                resultTitle: null,
                resultText: null,
                $purposeList: null,
                $recaptchaPlaceholders: null,
                validator: null,
                $form: null,
                $result: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };
    });
})(this);
